<template>
    <footer>
        <Stena v-if="isStena" v-bind="$props" />
        <Sembo v-else v-bind="$props" />
    </footer>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { Market } from '@shared/config/market/market.models';
    import { isStenaCompany } from '@shared/config/market/market.helpers';
    import { LogoTheme, FooterTheme } from '../Layout.interfaces';
    import Sembo from './Variants/Sembo.vue';
    import Stena from './Variants/Stena.vue';

    export default defineComponent({
        name: 'Footer',
        components: { Sembo, Stena },
        props: {
            market: {
                type: Object as PropType<Market>,
                required: true,
            },
            logoTheme: {
                type: String as PropType<LogoTheme>,
                required: true,
                default: 'inverted',
            },
            footerTheme: {
                type: String as PropType<FooterTheme>,
                required: true,
                default: 'primary',
            },
            showActions: {
                type: Boolean,
                default: false,
            },
        },
        setup(props) {
            const isStena = computed(() => isStenaCompany(props.market.number));
            return { isStena };
        },
    });
</script>
